import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL } from 'baseConfig';
const token = localStorage.getItem('token')

export const featureServiceApi = createApi({
    reducerPath: 'featureServiceApi',
    baseQuery: fetchBaseQuery({ baseUrl: `${BASE_URL}` }),
    tagTypes: ['Feature'],
    endpoints: (builder) => ({

        getAllFeatures: builder.query({
            query: () => `/v1/feature`,
            providesTags: ['Feature'],
        }),

        getFeatureByKey: builder.query({
            query: (featureKey) => `/v1/feature/byKey/${featureKey}`,
            providesTags: ['Feature'],
        }),

        toggleFeature: builder.mutation({
            query: ({ id, is_enabled }) => ({
                url: `/v1/feature/toggle/${id}`,
                method: 'PUT',
                headers: {
                    'authorization': token,
                    'Content-Type': 'application/json',
                },
                body: { is_enabled },
            }),
            invalidatesTags: ['Feature'],
        }),
    }),
});

export const { useGetAllFeaturesQuery, useGetFeatureByKeyQuery, useToggleFeatureMutation } = featureServiceApi;
